// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"138":"50b34a1616833e82","562":"4c3f3b97e274073e","731":"c8c865829858594e","881":"06575502901dc275"}[chunkId] + ".js";
};